import toast from "react-hot-toast";
import { axiosInstance } from "./api.service";
import authHeader from "./auth.header";

const getMessages = async (conversationId, signal) => {
	try {
		const res = await axiosInstance.get(`/messages/${conversationId}`, {
			headers: authHeader(),
			signal,
		});
		if (res.data.success === true) {
			return res.data;
		}
	} catch (err) {
		if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const sendMessages = async (data) => {
	try {
		const res = await axiosInstance.post("/messages", data, {
			headers: authHeader(),
		});
		if (res.data.success === true) {
			// toast.success(res.data.msg);
			return res.data;
		}
	} catch (err) {
		if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const getNotify = async (id, signal) => {
	try {
		const res = await axiosInstance.get(`/messages/notify/${id}`, {
			headers: authHeader(),
			signal,
		});
		if (res.data.success === true) {
			// toast.success(res.data.msg);
			return res.data;
		}
	} catch (err) {
		if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const MessageService = {
	getMessages,
	sendMessages,
	getNotify
};

export default MessageService;
